import React from 'react';

// Break-word wrapping splits long words at arbitrary points; hinting a break after each "/"
// (e.g. "Kirkenes/Hesseng") keeps slash-joined words wrapping in readable places instead.
// A crossTable row can hold more cells than its header row, so `cell` may be missing.
export const withWordBreakHints = (cell: string | undefined) =>
  (cell ?? '').split('/').map((part, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <React.Fragment key={index}>
      {index > 0 && '/'}
      {index > 0 && <wbr />}
      {part}
    </React.Fragment>
  ));
